<template>
  <div class="clinic-panel__mobile-side-menu">
    <template
      v-for="{
        classes, name, styles, sub, to,
      } in navigateItemsWithoutSettings"
    >
      <div
        v-if="sub"
        v-bind:key="name"
      >
        <input type="checkbox" hidden v-bind:id="name">
        <label
          title="Открыть подменю"
          v-bind:class="classes"
          class="clinic-panel__mobile-side-menu__link"
          v-bind:for="name"
        >
          <span
            v-bind:style="styles"
            class="clinic-panel__mobile-side-menu__icon"
          />
          <span>
            {{ name }}
          </span>
          <span class="clinic-panel__mobile-side-menu__arrow" />
        </label>
        <div class="clinic-panel__mobile-side-menu__sub">
          <template
            v-for="item in sub"
          >
            <router-link
              v-bind:key="item.name"
              class="clinic-panel__mobile-side-menu__link"
              v-bind:class="item.classes"
              v-bind:to="item.to"
            >{{item.name}}</router-link>
          </template>
        </div>
      </div>
      <router-link
        v-bind:class="classes"
        class="clinic-panel__mobile-side-menu__link"
        v-bind:key="name"
        v-bind:to="to"
        v-else
      >
        <span
          v-bind:style="styles"
          class="clinic-panel__mobile-side-menu__icon"
        />
        <span>{{ name }}</span>
        <span
          v-if="isShowCounters(name)"
        >
          ({{ getCount(name) }})
        </span>
        <span
          v-if="isShowAlerts(name)"
          class="clinic-panel__mobile-side-menu__mark-alert"
          title="Заполните все недостающие данные"
        >
          !
        </span>
      </router-link>
    </template>
    <div
      v-if="settingsItem"
    >
      <input type="checkbox" hidden v-bind:id="settingsItem.name">
      <label
        title="Открыть подменю"
        v-bind:class="settingsItem.classes"
        class="clinic-panel__mobile-side-menu__link"
        v-bind:for="settingsItem.name"
      >
        <span
          v-bind:style="settingsItem.styles"
          class="clinic-panel__mobile-side-menu__icon"
        />
        <span>
          {{ settingsItem.name }}
        </span>
        <span
          v-if="isShowAlerts(settingsItem.name)"
          class="clinic-panel__mobile-side-menu__mark-alert"
          title="Заполните все недостающие данные"
        >
          !
        </span>
        <span class="clinic-panel__mobile-side-menu__arrow" />
      </label>
      <div class="clinic-panel__mobile-side-menu__sub">
        <template
          v-for="item in settingsItem.sub"
        >
          <router-link
            v-bind:key="item.name"
            class="clinic-panel__mobile-side-menu__link"
            v-bind:class="item.classes"
            v-bind:to="item.to"
          >
            {{item.name}}
            <span
              v-if="isShowAlerts(item.name)"
              class="clinic-panel__mobile-side-menu__mark-alert"
              title="Заполните все недостающие данные"
            >
              !
            </span>
          </router-link>
        </template>
      </div>
    </div>
    <button
      v-if="helpItem"
      type="button"
      class="clinic-panel__mobile-side-menu__link"
      v-bind:class="helpItem.classes"
      v-bind:key="helpItem.name"
      v-on:click="onRouteToHelp(helpItem.to); helpButtonReachGoal()"
    >
      <span
        v-bind:style="helpItem.styles"
        class="clinic-panel__mobile-side-menu__icon"
        :class="{ 'help-item': helpItem }"
      />
      <span>{{ helpItem.name }}</span>
    </button>
    <div class="clinic-panel__mobile-side-menu__bottom-group">
      <button
        class="clinic-panel__mobile-side-menu__link"
        type="button"
        v-on:click="showSuggestionIdeaPopup"
      >
        Предложить идею
      </button>
      <router-link
        class="clinic-panel__mobile-side-menu__link"
        :to="{ name: 'ClinicPanelUserProfile' }"
      >
        Мой профиль
      </router-link>
      <button
        class="head-panel__exit"
        type="button"
        v-on:click="logout"
      >
        Выход
      </button>
    </div>
  </div>
</template>
<script>
import { GOAL_CLICK_HELP_BUTTON } from '@/plugins/metric';

export default {
  computed: {
    /**
     * @description Навигационные элементы без настроек и помощи
     * @returns {*[]}
     */
    navigateItemsWithoutSettings() {
      return this.navigateItems.filter((item) => item.name !== 'Настройки' && item.name !== 'Помощь');
    },
    /**
     * @description Элемент с настройками
     * @returns {*}
     */
    settingsItem() {
      return this.navigateItems.find((item) => item.name === 'Настройки');
    },
    /**
     * @description Элемент с помощью
     * @returns {*}
     */
    helpItem() {
      return this.navigateItems.find((item) => item.name === 'Помощь');
    },
  },
  data() {
    return {
      submenu: false,
    };
  },
  methods: {
    /**
     * @description Отправить событие выхода
     */
    logout() {
      this.$emit('logout');
    },
    /**
     * @description Отправить событие показа попапа "Предложить идею"
     */
    showSuggestionIdeaPopup() {
      this.$emit('show-suggestion-idea-popup');
    },
    /**
     * @description Получить количество для индикатора
     * @param name
     */
    getCount(name) {
      const currentItem = this.counters.find((item) => (item.name === name));
      return currentItem.count;
    },
    /**
     * @description Обработать переход на страницу помощи.
     * @param {Object} link
     */
    onRouteToHelp(link) {
      if (this.$route.name !== link.name) {
        this.$router.push(link);
      }
    },
    /**
     * @description Обработать достижение цели нажатия на кнопку "Помощь"
     * @return {void}
     */
    helpButtonReachGoal() {
      this.$goal(GOAL_CLICK_HELP_BUTTON);
    },
  },
  name: 'HeaderBurgerMenuList',
  props: {
    counters: { type: Array, default: () => [] },
    alerts: { type: Array, default: () => [] },
    isShowCounters: { type: Function, required: true },
    isShowAlerts: { type: Function, required: true },
    navigateItems: { type: Array, default: () => [] },
  },
};
</script>
<style lang="scss">
.clinic-panel__mobile-side-menu {
  display: none;
}
@media screen and (max-width: 960px) {
  .clinic-panel__mobile-side-menu {
    display: flex;
    flex-direction: column;
    gap: 15px;
    color: var(--fill-color);
    &__bottom-group {
      display: grid;
      row-gap: 15px;
      margin-top: 30px;
    }
    &__link {
      display: flex;
      align-items: center;
      gap: 10px;
      color: var(--fill-color) !important;
      text-decoration: none;
      line-height: 25px;
      &.last {
        margin-bottom: 15px;
      }
      &.router-link-active {
        font-weight: 700;
      }
    }
    &__icon {
      display: inline-flex;
      width: 20px;
      height: 20px;
      background-size: contain;
      &.help-item {
        width: 24px;
        height: 24px;
      }
    }
    &__mark-alert {
      font-size: 20px;
      font-weight: 600;
      color: #f21e1e
    }
    &__arrow {
      display: inline-flex;
      align-items: center;
      background-image: url("@/assets/img/checked/checked-light.svg");
      background-position: center;
      width: 20px;
      height: 10px;
      margin: 0 0 0 10px;
    }
    &__sub {
      display: none;
      flex-direction: column;
      gap: 15px;
      margin: 15px 0 0 0;
      padding: 0 0 0 30px;
    }
    &__caption {
      font-weight: 600;
      color: #a5a5a5 !important;
      text-transform: uppercase;
      margin: 0 0 10px 0;
    }
    input[type=checkbox]:checked ~ label ~ &__sub {
      display: flex;
    }
    input[type=checkbox]:checked ~ &__link > &__arrow {
      transform: rotate(180deg);
    }
  }
}
</style>
